import { styled } from '@mui/material';
import { Container, Tabs, Tab, Grid } from '@mui/material';
import { ChangeEvent, useState } from "react";
//import PageHeader from '../../common/PageHeader';
//import { useSelector } from "react-redux";
//import { RootState } from "src/redux-store/appStore";
import PetReportDetails from './PetReportDetails'
import PetLicenseDetails from "./PetLicenseDetails";
import IntactPets from "./IntactPets";
import DogLicense from "./DogLicense";
import ReportLayout from '../Common/report/ReportLayout';

const TabsWrapper = styled(Tabs)(
    () => `
      .MuiTabs-scrollableX {
        overflow-x: auto !important;
      },

  `
);

const PetReport: React.FC = () => {
    // Default tab logic
    const defaultTab = 'report_details';
    //const theme = useTheme();
    const [currentTab, setCurrentTab] = useState<string>(defaultTab);
    //const userDetails = useSelector((store: RootState) => store.user.userDetails);

    const tabs = [
        { value: 'report_details', label: 'State Report' },
        { value: 'license_details', label: 'License Details' },
        { value: 'intact_pets', label: 'Intact Pets' },
        { value: 'dog_license', label: 'Dog License' },
    ];

    // Handle tab change
    const handleTabsChange = (event: ChangeEvent<unknown>, value: string): void => {
        setCurrentTab(value);
    };

    return (
        <>

            <Container maxWidth="xl">
                <ReportLayout title="Pet License Report">
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="stretch"
                        spacing={3}

                    >
                        <Grid item xs={12} mx={3} mt={2} >
                            <TabsWrapper

                                onChange={handleTabsChange}
                                value={currentTab}
                                variant="scrollable"
                                scrollButtons="auto"
                                textColor="primary"
                                indicatorColor="primary"
                            >
                                {tabs.map((tab) => (
                                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                                ))}
                            </TabsWrapper>
                        </Grid>
                        <Grid item xs={12}>
                            {currentTab === 'report_details' && <PetReportDetails />}
                            {currentTab === 'license_details' && <PetLicenseDetails />}
                            {currentTab === 'intact_pets' && <IntactPets />}
                            {currentTab === 'dog_license' && <DogLicense />}
                        </Grid>
                    </Grid>
                </ReportLayout>
            </Container>

        </>
    );
}

export default PetReport